let BUFFER = 32 // this works like a padding without affecting the parent container

export function getCellSize({ height, width, rows, columns }) {
  let containerRatio = height / width
  let gridRatio = rows / columns
  return containerRatio > gridRatio
    ? Math.floor((width - BUFFER) / columns)
    : Math.floor((height - BUFFER) / rows)
}
